import React from 'react'

// components
import SocialLinks from '../socialLinks/'

// styles
import './footer.css'

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default () =>
  <footer className="footer">
    <SocialLinks />
  </footer>
  